module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/16-be92674036db750088bebd7934d8b36f.jpg";